export default "__VITE_ASSET__CgAGIzlB__"